import React from 'react'
import SvgIcon, { SvgIconProps } from 'components/Luxkit/SvgIcon'

/**
 * @deprecated Legacy icon.
 * */
function TourStartIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 29.82 29.82">
      <path d="M14.8 15.77a.75.75 0 10-.72-.75.74.74 0 00.72.75z"/>
      <path d="M20.73 10.74c.93-1.64 1.78-3.34 2.61-5.19a.52.52 0 00-.13-.6.51.51 0 00-.61-.06 6 6 0 01-3.1.82 16.52 16.52 0 01-4.45-.87 17.16 17.16 0 00-4.73-.92 7 7 0 00-3.63 1 .51.51 0 00-.26.45v20a.52.52 0 00.53.52.52.52 0 00.52-.52V14.75a5.94 5.94 0 012.84-.69 16.18 16.18 0 014.44.88 17.15 17.15 0 004.74.91 7.05 7.05 0 003.62-1 .55.55 0 00.26-.38.53.53 0 00-.14-.43 25.51 25.51 0 01-2.51-3.3zM19.5 14.8a16.14 16.14 0 01-4.45-.87 17.08 17.08 0 00-4.73-.93 7.06 7.06 0 00-2.84.56V5.65A5.93 5.93 0 0110.32 5a16.15 16.15 0 014.44.87 17.15 17.15 0 004.74.91 7 7 0 002.3-.36c-.68 1.44-1.38 2.79-2.13 4.1a.52.52 0 000 .54A28 28 0 0022 14.28a6 6 0 01-2.5.52z"/>
    </SvgIcon>
  )
}
export default TourStartIcon
